import { Box, Chip, Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

import { ManageEmailDomainsButton } from 'contacts/components/ContactGroupList';
import { IContactGroup } from 'contacts/types';
import { getAgGridTableCellData } from 'core/utils';
import { Variant } from 'theme/enums';

export const DomainsCell = ({ value: domains = [], ...rest }: ICellRendererParams) => {
  const { t } = useTranslation();

  const data = getAgGridTableCellData({ value: domains, ...rest }, 'domains');

  return (
    <Stack gap={1} sx={{ padding: 1 }}>
      {domains.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            alignItems: 'flex-start',
          }}
        >
          {domains.map((domain: string) => (
            <Chip key={domain} variant={Variant.OUTLINED}>{`@${domain}`}</Chip>
          ))}
        </Box>
      )}

      {data && (
        <Box display={'flex'} justifyContent={'flex-end'}>
          <ManageEmailDomainsButton
            text={t('buttonLabelManageDomains')}
            variant={Variant.PLAIN}
            contactGroup={data as IContactGroup}
          />
        </Box>
      )}
    </Stack>
  );
};
